/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useMemo, useState} from 'react'
import {KTCard, KTCardBody, KTIcon} from '../../../../_websoft/helpers'
import {ToastContainer} from 'react-toastify'
import LoadingComponent from '../../../components/LoadingComponent/LoadingComponent'
import {RolneZaProizvodnjuModel} from '../../../models/RolneZaProizvodnju'
import {
    getRolneUProizvodnju,
    getRolneZaProizvodnju,
    updateProizvediRolnu,
} from '../../../api/rolneProizvodnju'
import notifyToast from '../../../components/Toast/Toast'
import {flexRender, getCoreRowModel, useReactTable} from '@tanstack/react-table'
import KrajRasjecanjeModal from './components/KrajRasjecanjeModal'
import {useParams} from 'react-router-dom'

const Rasjecanje = () => {
    const {odjelId} = useParams()
    const id = useMemo(() => Number(odjelId), [odjelId])

    const [dataTable1, setDataTable1] = useState<RolneZaProizvodnjuModel[]>([])
    const [dataTable2, setDataTable2] = useState<RolneZaProizvodnjuModel[]>([])
    const [loading, setLoading] = useState(true)

    const [isModalOpen, setisModalOpen] = useState(false)
    const [krajData, setKrajData] = useState<any>()

    const isRasjecanje = id === 1
    const pageTitle = isRasjecanje ? 'Rasjecanje' : 'Odmotavanje'
    const pageSubtitle = 'Upravljanje rolama u procesu'

    const getStatusBadge = (status: number) => {
        if (status === 0)
            return (
                <span className='badge badge-light-warning fw-semibold'>
          <KTIcon iconName='time' className='fs-6 me-1' />
          Na čekanju
        </span>
            )
        if (status === 5)
            return (
                <span className='badge badge-light-success fw-semibold'>
          <KTIcon iconName='loading' className='fs-6 me-1' />
          U proizvodnji
        </span>
            )
        return <span className='badge badge-light fw-semibold'>—</span>
    }

    const updateTable1 = () => {
        setLoading(true)
        getRolneZaProizvodnju({odjelId: id})
            .then((response) => {
                const data = response.data['data']
                setDataTable1(data)
            })
            .catch((error) => {
                console.error('Error: ', error)
                notifyToast(false, error)
            })
            .finally(() => setLoading(false))
    }

    const updateTable2 = () => {
        setLoading(true)
        getRolneUProizvodnju({odjelId: id})
            .then((response) => {
                const data = response.data['data']
                setDataTable2(data)
            })
            .catch((error) => {
                console.error('Error: ', error)
                notifyToast(false, error)
            })
            .finally(() => setLoading(false))
    }

    useEffect(() => {
        updateTable1()
        updateTable2()
    }, [])

    const onClickStart = (rolnaId: number) => {
        updateProizvediRolnu({rolnaId})
            .then((response) => notifyToast(true, response.message))
            .catch((error) => notifyToast(false, error.response?.data?.message ?? 'Greška'))
            .finally(() => {
                updateTable1()
                updateTable2()
            })
    }

    const columnsTable1 = [
        {id: 'RŠ#', header: 'RŠ#', accessorKey: 'Id'},
        {id: 'Z', header: 'Z-', accessorKey: 'ZahtjevID'},
        {id: 'Broj rolne', header: 'R-Rolna', accessorKey: 'BrojRolne'},
        {
            id: 'Šir/Dužina',
            header: 'Šir/Dužina',
            cell: ({row}: any) => row.original.Sirina ?? row.original.Duzina,
        },
        {
            id: 'Paleta',
            header: 'Paleta',
            cell: ({row}: any) => <span className='badge badge-light-danger fw-semibold'>{row.original.Pakovanje}</span>,
        },
        {id: 'Napomena', header: 'Napomena', accessorKey: 'Napomena'},
        {
            id: 'Status',
            header: 'Status',
            cell: ({row}: any) => getStatusBadge(row.original.Status),
        },
        {
            id: 'btn',
            header: '',
            cell: ({row}: any) => (
                <button
                    className='btn btn-sm btn-success'
                    onClick={() => onClickStart(row.original.Id)}
                    title='Start proizvodnje'
                >
                    <KTIcon iconName='play' className='fs-5 me-1' />
                    Start
                </button>
            ),
        },
    ]

    const columnsTable2 = [
        {id: 'RŠ#', header: 'RŠ#', accessorKey: 'Id'},
        {id: 'Broj rolne', header: 'R-Rolna', accessorKey: 'BrojRolne'},
        {
            id: 'Šir/Dužina',
            header: 'Šir/Dužina',
            cell: ({row}: any) => row.original.Sirina ?? row.original.Duzina,
        },
        {
            id: 'Status',
            header: 'Status',
            cell: ({row}: any) => getStatusBadge(row.original.Status),
        },
        {
            id: 'btn',
            header: '',
            cell: ({row}: any) => (
                <button
                    className='btn btn-sm btn-primary'
                    onClick={() => {
                        setKrajData(row.original)
                        setisModalOpen(true)
                    }}
                    title='Završi stavku'
                >
                    <KTIcon iconName='check-circle' className='fs-5 me-1' />
                    Kraj
                </button>
            ),
        },
    ]

    const table1 = useReactTable({
        data: dataTable1,
        columns: columnsTable1 as any,
        getCoreRowModel: getCoreRowModel(),
    })

    const table2 = useReactTable({
        data: dataTable2,
        columns: columnsTable2 as any,
        getCoreRowModel: getCoreRowModel(),
    })

    const EmptyState = ({text}: {text: string}) => (
        <div className='text-center py-10'>
            <div className='mb-3'>
        <span className='symbol symbol-70px'>
          <span className='symbol-label bg-light'>
            <KTIcon iconName='file-deleted' className='fs-2x text-muted' />
          </span>
        </span>
            </div>
            <div className='text-muted fw-semibold'>{text}</div>
        </div>
    )

    return (
        <div className='container-fluid'>
            <ToastContainer />

            {krajData && (
                <KrajRasjecanjeModal
                    isModalOpen={isModalOpen}
                    setisModalOpen={setisModalOpen}
                    data={krajData}
                    update={updateTable2}
                />
            )}

            {/* Page Header */}
            <div className='d-flex flex-wrap align-items-center justify-content-between mb-7'>
                <div className='d-flex align-items-center gap-4'>
                  <span className={`symbol symbol-50px`}>
                    <span className={`symbol-label bg-${isRasjecanje ? 'success' : 'info'}`}>
                      <i className={isRasjecanje ? 'bi-scissors fs-2 text-white' : 'bi-arrow-repeat fs-2 text-white'} />
                    </span>
                  </span>

                    <div>
                        <div className='d-flex align-items-center gap-3'>
                            <h1 className='fw-bold mb-0'>{pageTitle}</h1>
                            <span className='badge badge-light fw-semibold'>Odjel #{id}</span>
                        </div>
                        <div className='text-muted fw-semibold'>{pageSubtitle}</div>
                    </div>
                </div>

                <div className='d-flex gap-2'>
                    <button
                        className='btn btn-sm btn-light'
                        onClick={() => {
                            updateTable1()
                            updateTable2()
                        }}
                    >
                        <KTIcon iconName='arrows-loop' className='fs-5 me-1' />
                        Osvježi
                    </button>
                </div>
            </div>

            <div className='row g-6'>
                {/* LEFT: Waiting */}
                <div className='col-12 col-xxl-6'>
                    <KTCard>
                        <div className='card-header border-0 pt-6 pb-4'>
                            <div className='card-title d-flex align-items-center gap-3'>
                                <KTIcon iconName='time' className='fs-2 text-warning' />
                                <div>
                                    <div className='fw-bold fs-3'>Stavke na čekanju</div>
                                    <div className='text-muted fw-semibold'>Spremne za start</div>
                                </div>
                            </div>

                            <div className='card-toolbar'>
                <span className='badge badge-light-warning fw-semibold'>
                  {dataTable1?.length ?? 0} stavki
                </span>
                            </div>
                        </div>

                        <KTCardBody className='pt-0'>
                            {loading ? (
                                <LoadingComponent />
                            ) : (
                                <div className='table-responsive'>
                                    <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                                        <thead>
                                        {table1.getHeaderGroups().map((headerGroup) => (
                                            <tr key={headerGroup.id} className='fw-bolder text-muted text-uppercase fs-7'>
                                                {headerGroup.headers.map((header) => (
                                                    <th key={header.id} className='min-w-75px'>
                                                        {flexRender(header.column.columnDef.header, header.getContext())}
                                                    </th>
                                                ))}
                                            </tr>
                                        ))}
                                        </thead>

                                        <tbody>
                                        {table1.getRowModel().rows?.length ? (
                                            table1.getRowModel().rows.map((row) => (
                                                <tr key={row.id} className='hover'>
                                                    {row.getVisibleCells().map((cell) => (
                                                        <td key={cell.id} className='fw-semibold text-gray-700'>
                                                            {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                                        </td>
                                                    ))}
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={8}>
                                                    <EmptyState text='Trenutno nema stavki na čekanju.' />
                                                </td>
                                            </tr>
                                        )}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </KTCardBody>
                    </KTCard>
                </div>

                {/* RIGHT: In production */}
                <div className='col-12 col-xxl-6'>
                    <KTCard>
                        <div className='card-header border-0 pt-6 pb-4'>
                            <div className='card-title d-flex align-items-center gap-3'>
                                <KTIcon iconName='loading' className='fs-2 text-success' />
                                <div>
                                    <div className='fw-bold fs-3'>U proizvodnji</div>
                                    <div className='text-muted fw-semibold'>Aktivne stavke ({pageTitle.toLowerCase()})</div>
                                </div>
                            </div>

                            <div className='card-toolbar'>
                <span className='badge badge-light-success fw-semibold'>
                  {dataTable2?.length ?? 0} aktivno
                </span>
                            </div>
                        </div>

                        <KTCardBody className='pt-0'>
                            {loading ? (
                                <LoadingComponent />
                            ) : (
                                <div className='table-responsive'>
                                    <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                                        <thead>
                                        {table2.getHeaderGroups().map((headerGroup) => (
                                            <tr key={headerGroup.id} className='fw-bolder text-muted text-uppercase fs-7'>
                                                {headerGroup.headers.map((header) => (
                                                    <th key={header.id} className='min-w-75px'>
                                                        {flexRender(header.column.columnDef.header, header.getContext())}
                                                    </th>
                                                ))}
                                            </tr>
                                        ))}
                                        </thead>

                                        <tbody>
                                        {table2.getRowModel().rows?.length ? (
                                            table2.getRowModel().rows.map((row) => (
                                                <tr key={row.id} className='hover'>
                                                    {row.getVisibleCells().map((cell) => (
                                                        <td key={cell.id} className='fw-semibold text-gray-700'>
                                                            {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                                        </td>
                                                    ))}
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={6}>
                                                    <EmptyState text='Trenutno nema aktivnih stavki u proizvodnji.' />
                                                </td>
                                            </tr>
                                        )}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </KTCardBody>
                    </KTCard>
                </div>
            </div>
        </div>
    )
}

export default Rasjecanje
